//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headerSearch from "../components/header-search";
import instance from "../assets/js/instance";
import { Toast } from "vant";

export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      swiperList: [
        {
          id: 1,
          img: "s1.jpg"
        },
        {
          id: 2,
          img: "s2.jpg"
        }
      ],
      brandList: [
        {
          key: "A",
          list: []
        },
        {
          key: "B",
          list: []
        },
        {
          key: "C",
          list: []
        },
        {
          key: "D",
          list: []
        },
        {
          key: "E",
          list: []
        },
        {
          key: "F",
          list: []
        },
        {
          key: "G",
          list: []
        },
        {
          key: "H",
          list: []
        },
        {
          key: "I",
          list: []
        },
        {
          key: "J",
          list: []
        },
        {
          key: "K",
          list: []
        },
        {
          key: "L",
          list: []
        },
        {
          key: "M",
          list: []
        },
        {
          key: "N",
          list: []
        },
        {
          key: "O",
          list: []
        },
        {
          key: "P",
          list: []
        },
        {
          key: "Q",
          list: []
        },
        {
          key: "R",
          list: []
        },
        {
          key: "S",
          list: []
        },
        {
          key: "T",
          list: []
        },
        {
          key: "U",
          list: []
        },
        {
          key: "V",
          list: []
        },
        {
          key: "W",
          list: []
        },
        {
          key: "X",
          list: []
        },
        {
          key: "Y",
          list: []
        },
        {
          key: "Z",
          list: []
        }
      ],
      slogan: "",
      min: true,
      scroll: true,
      canShow: false
    };
  },
  computed: {
    options() {
      return this.$t("home");
    },

    path() {
      return this.$store.getters.getPath;
    },

    cMenu() {
      return this.$t("cMenu");
    },

    isPhone() {
      return this.$store.getters.getIsPhone;
    }
  },
  components: {
    headerSearch
  },
  methods: {
    updateView() {
      var arr = Array.prototype.slice.call(this.$refs.brandList.childNodes);
      arr.forEach((item, index) => {
        this.brandList[index].height = parseInt(
          window.getComputedStyle(item).height.replace("px", "")
        );
        this.brandList[index].top = item.offsetTop;
      });
    },

    go(top) {
      this.goScroll(top);
    },

    goScroll(top) {
      var requestAnimationFrame;
      if (window.requestAnimationFrame) {
        requestAnimationFrame = window.requestAnimationFrame;
      } else {
        requestAnimationFrame = setTimeout(fn => {
          fn();
        }, 17);
      }
      // 当前时间
      var t = 0;
      // 初始值
      var b = window.scrollY;
      // 变化量
      var c = top - b;
      // 持续时间
      var d = 20;
      var step = () => {
        var v = this.run(t, b, c, d);
        // console.log(v)
        window.scrollTo(0, v);
        t += 1;
        if (t <= d) {
          requestAnimationFrame(step);
        }
      };
      step();
    },
    // 运动
    run(t, b, c, d) {
      return c * (t /= d) * t + b;
    },

    getInfo() {
      instance
        .get("/api/index/getBanners")
        .then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.slogan = data.data.remark;
            this.swiperList = data.data.list;
            this.$nextTick(() => {
              if (!this.isPhone) {
                var mySwiper = new Swiper(".swiper-container", {
                  loop: true, // 循环模式选项
                  autoplay: {
                    autoplay: true,
                    delay: 3000
                  },
                  // 如果需要分页器
                  pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                  }
                });
              }
            });
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    getList() {
      this.showToast();
      instance
        .get("/api/index/getBrands")
        .then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.checkoutList(data.data.list);
          }
          Toast.clear();
        })
        .catch(e => {
          console.log(e);
          Toast.clear();
        });
    },

    checkoutList(data) {
      let arr = data;
      let list = [...this.brandList];
      arr.forEach(item => {
        list.forEach(father => {
          if (item.current_char === father.key) {
            father.list.push(item);
          }
        });
      });
      this.brandList = list;
    },

    showToast() {
      Toast.loading({
        duration: 0,
        mask: true,
        message: this.options.loading
      });
    },

    init() {
      if (!instance.defaults.headers.language) {
        return false;
      }
      this.getInfo();
      this.getList();
    }
  },
  mounted() {
    window.onscroll = () => {
      if (this.scroll) {
        this.scroll = false;
        setTimeout(() => {
          var y = window.scrollY;
          if (y > 660) {
            this.$refs.menu.style.position = "fixed";
          } else {
            this.$refs.menu.style.position = "absolute";
          }
          this.updateView();
          this.scroll = true;
        }, 200);
      }
    };

    this.init();
    window.subscribe.listen("languageChange", () => {
      this.init();
    });
  },
  destroyed() {
    window.onscroll = null;
  }
};
